/**
 * @file
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-11 RFC 9110 11 HTTP Authentication}
 */

import {
  FieldName,
  FieldType,
  FieldValueFormat,
  listFieldFormat,
  singleFieldFormat,
  stringFieldValueFormat,
} from "./fields";

/**
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-11.4 RFC 9110 Section 11.4 Credentials}
 */
export class Credentials {
  // TODO: support auth-param
  constructor(
    readonly authScheme: string,
    readonly token: string,
  ) {}
}

export const credentialsFieldValueFormat: FieldValueFormat<Credentials> = {
  read(fieldValue: string) {
    const [authScheme, token] = fieldValue.split(" ");
    return new Credentials(authScheme, token);
  },
  write(credentials: Credentials) {
    return `${credentials.authScheme} ${credentials.token}`;
  },
};

/**
 * Authentication-Info
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-11.6.3 RFC 9110 11.6.3 Authentication-Info}
 */
export const AuthenticationInfoField = new FieldType(
  new FieldName("Authentication-Info"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Authorization
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-11.6.2 RFC 9110 11.6.2 Authorization}
 */
export const AuthorizationField = new FieldType(
  new FieldName("Authorization"),
  singleFieldFormat(credentialsFieldValueFormat),
);

/**
 * Proxy-Authenticate
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-11.7.1 RFC 9110 11.7.1 Proxy-Authenticate}
 */
export const ProxyAuthenticateField = new FieldType(
  new FieldName("Proxy-Authenticate"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Proxy-Authentication-Info
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-11.7.3 RFC 9110 11.7.3 Proxy-Authentication-Info}
 */
export const ProxyAuthenticationInfoField = new FieldType(
  new FieldName("Proxy-Authentication-Info"),
  listFieldFormat(stringFieldValueFormat),
);

/**
 * Proxy-Authorization
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-11.7.2 RFC 9110 11.7.2 Proxy-Authorization}
 */
export const ProxyAuthorizationField = new FieldType(
  new FieldName("Proxy-Authorization"),
  singleFieldFormat(credentialsFieldValueFormat),
);

/**
 * WWW-Authenticate
 * @see {@link https://www.rfc-editor.org/rfc/rfc9110#section-11.6.1 RFC 9110 11.6.1 WWW-Authenticate}
 */
export const WwwAuthenticateField = new FieldType(
  new FieldName("WWW-Authenticate"),
  listFieldFormat(stringFieldValueFormat),
);
